import { Pipe, PipeTransform } from '@angular/core';
import { formatSubmittedValue } from '@app/assessment/services/measure-control-value-converter';
import { FormControlValueType } from '@app/assessment/services/quality-goal-form.service';
import { getMaskByUnit, getSuffixByUnit, mapPrecisionToMask, Unit } from '@app/shared/models/unit';
import { NgxMaskPipe } from 'ngx-mask';

function formatValue(value: string | number | null, unit: Unit | null, customPrecision?: number): FormControlValueType {
    const formattedValue = formatSubmittedValue(value, unit, customPrecision);

    if (unit === Unit.BOOLEAN) {
        return formattedValue ? $localize`:@@term.yes:Ja` : $localize`:@@term.no:Nein`;
    }

    return formattedValue;
}

function createMask(
    formattedValue: FormControlValueType,
    unit: Unit | null,
    customPrecision?: number,
): string | null {
    if ('number' === typeof customPrecision) {
        return mapPrecisionToMask(customPrecision);
    }

    return unit && 'string' !== typeof formattedValue
        ? getMaskByUnit(unit)
        : null;
}

export interface FormatValuePipeOptions {
    customPrecision?: number;
    evaluated: boolean | null;
}

@Pipe({
    name: 'formatValue',
    standalone: true,
})
export class FormatValuePipe implements PipeTransform {

    constructor(
        private maskPipe: NgxMaskPipe,
    ) {
    }

    transform(
        value: string | number | null,
        unit: Unit | null,
        options?: Partial<FormatValuePipeOptions>,
    ): string {
        const customPrecision = options?.customPrecision;
        const evaluated = options?.evaluated ?? true;

        if (!evaluated) {
            return 'Nicht zutreffend';
        }

        const formattedValue = formatValue(value, unit, customPrecision);
        const formattedStringValue = formattedValue?.toString();

        if (undefined === formattedStringValue) {
            return '';
        }

        const suffix = getSuffixByUnit(unit);
        const mask = createMask(formattedValue, unit, customPrecision);

        const formattedWithoutSuffix = mask
            ? this.maskPipe.transform(formattedStringValue, mask)
            : formattedStringValue;

        return `${formattedWithoutSuffix}${suffix}`;
    }
}
